import { useField } from 'formik';
import { FormLabel, FormControl, FormHelperText } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

import { controlError } from 'utils';

export interface DatePickerFieldProps extends Omit<
  DatePickerProps,
  'label' | 'value' | 'onChange'
> {
  name: string;
  label: string;
  format?: string;
  placeholder?: string;
  labelOutside?: boolean;
  hideFormatText?: boolean;
}

export const DatePickerField = ({
  name,
  label,
  className,
  placeholder,
  labelOutside,
  hideFormatText,
  format = 'MM/DD/YYYY',
  ...props
}: DatePickerFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);
  const hasError = Boolean(errorText);

  return (
    <FormControl error={hasError} className={className}>
      {labelOutside && label && (
        <FormLabel className="text-black-primary mb-1">{label}</FormLabel>
      )}
      <DatePicker
        onClose={() => helpers.setTouched(true)}
        value={field.value === '' ? null : field.value}
        onChange={async (value) => {
          await helpers.setTouched(true, false);
          helpers.setValue(value);
        }}
        {...props}
        slotProps={{
          textField: {
            error: hasError,
            variant: 'filled',
            helperText: !hideFormatText && format,
            onBlur: () => helpers.setTouched(true),
            label: !labelOutside ? label : undefined,
            slotProps: {
              htmlInput: {
                placeholder,
              },
              input: {
                className: labelOutside || !label ? 'withoutLabel' : '',
              },
            },
          },
        }}
      />
      {hasError && (
        <FormHelperText className="!ml-0">{errorText}</FormHelperText>
      )}
    </FormControl>
  );
};
